"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_USER_PROMOTIONS_ENDPOINT = {
    postInviteAFriend: '/user-company/{{version}}/users/{{userUuid}}/invites',
    getReferralInfo: '/user-company/{{version}}/users/{{userUuid}}/referral-info',
    addPromotionCode: '/promotions/{{version}}/users/{{userUuid}}/promotions/from-code/{{promotionCode}}',
    checkPromotion: '/user-company/{{version}}/users/promotions/{{promotionCode}}/check?cs_operator_uuid={{csOperatorUuid}}',
};
